import { PermissionCode } from '@core-frontend/core-frontend';
import { lazy } from 'react';

import { AppRoutes } from '../AppRoutes';
import type { RouteProtectedWithPermissionObject } from '../types';

const CompanyOnboardingPage = lazy(() =>
  import('@/pages/auth/ui').then((module) => ({
    default: module.CompanyOnboardingPage,
  }))
);

const OrganizationsPage = lazy(() =>
  import('@/pages/organization/ui').then((module) => ({
    default: module.OrganizationsPage,
  }))
);

const OrganizationDetailsPage = lazy(() =>
  import('@/pages/organization/ui').then((module) => ({
    default: module.OrganizationDetailsPage,
  }))
);

const DomainsPage = lazy(() =>
  import('@/pages/organization/ui').then((module) => ({
    default: module.DomainsPage,
  }))
);

const organizationCoreRoutes: RouteProtectedWithPermissionObject[] = [
  {
    path: AppRoutes.ORGANIZATION_CREATE,
    element: <CompanyOnboardingPage />,
    permissions: [PermissionCode.ADD_ORGANIZATION],
  },
  {
    path: AppRoutes.ORGANIZATIONS,
    element: <OrganizationsPage />,
    permissions: [PermissionCode.VIEW_ORGANIZATION],
  },
  {
    path: AppRoutes.ORGANIZATIONS_DETAILS,
    element: <OrganizationDetailsPage />,
    permissions: [PermissionCode.VIEW_ORGANIZATION],
  },
  {
    path: AppRoutes.DOMAINS,
    element: <DomainsPage />,
    permissions: [PermissionCode.VIEW_DOMAIN],
  },
];

const organizationsTenantRoutes: RouteProtectedWithPermissionObject[] = [
  {
    path: AppRoutes.ORGANIZATIONS,
    element: <OrganizationsPage />,
    permissions: [PermissionCode.VIEW_ORGANIZATION],
  },
  {
    path: AppRoutes.ORGANIZATIONS_DETAILS,
    element: <OrganizationDetailsPage />,
    permissions: [PermissionCode.VIEW_ORGANIZATION],
  },
];

export const organizationsRouter: RouteProtectedWithPermissionObject[] =
  window.isCurrentHostEqualsCore
    ? organizationCoreRoutes
    : organizationsTenantRoutes;
